/**
 * ErrorVU.js
 * @author Nicolás Panaino
 */

//Dependencies
import React, { Component } from 'react';
import { connect } from 'react-redux'
import $ from 'jquery';
import { disableRiesgoNet } from '../../../actions/actions';

//material-ui
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

//Components
import { Layout } from '../layout/Layout';

//Assets
import warning from '../../../static/img/face-error.png';
import checked from "../../../static/img/checked.png"

//Services
import { processToken } from './../services/tokenService';
import { processFlow } from './../services/flowService';
import { handleErrorMessages } from './../error/services/messageService';

class ErrorVU extends Component {

    constructor(props) {
        super(props);
        this.state = { }
        this.goBack = this.goBack.bind(this);
    }

    componentDidMount() {
        $(".load").fadeOut(700);
    }

    goBack() {
        $(".load").fadeIn(700);
        this.props.history.goBack();
    }

    render() {
        const footer = {
            button: {
                action : this.goBack,
                text : "reintentar"
            }
        };
        const body = { img : { src : warning } }
        return (
            <Layout footer={footer} body={body}
                tieneFooter>
                <Grid container
                    direction="row"
                    justify="center"
                    alignItems="center">
                    <Grid item xs={12} >
                        <div className="content-description">
                            <h5 className="title" >Ups... algo falló !</h5>
                            <div className="centerText">VOLVE A SACAR LA FOTO Y RECORDA QUÉ: </div>

                            <li className="listado"><img src={require('../../../static/img/checked.png')} className="checkedImage" alt="" /> <span className="tipText"></span> Haya suficiente luz </li>
                            <li className="listado"><img src={require('../../../static/img/checked.png')} className="checkedImage" alt="" /> <span className="tipText">Que tenga reflejos la imagen</span> </li>
                            <li className="listado"><img src={require('../../../static/img/checked.png')} className="checkedImage" alt="" /> <span className="tipText">Se vea completa la imagen</span> </li>
                        </div>                       
                    </Grid>
                </Grid>
            </Layout>
        );
    }
}

const mapStateToProps = function (state) {
    return {
        riesgoURLNet: state.riesgoURLNet.url,
        riesgoNetEnabled: state.riesgoNetEnabler.enable,
        paso: state.navigation.paso,
        message: state.error.message
    }
}

export default connect(mapStateToProps)(ErrorVU);


// WEBPACK FOOTER //
// ./src/components/OnBoarding/error/ErrorVU.js